<template>
  <div class="plk_javascript">
    <Menu></Menu>
    <div class="javascript">
      <codemirror v-model="code" :options="cmOptions" />
    </div>
  </div>
</template>

<script>
import i18n from './i18n'
import { codemirror } from 'vue-codemirror'
import Menu from './components/Menu/Menu'
import 'codemirror/lib/codemirror.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/elegant.css'
import { DESIGN } from '@/store'

export default {
  name: 'javascript',
  components: {
    codemirror,
    Menu
  },
  data () {
    return {
      cmOptions: {
        tabSize: 2,
        autoCloseTags: true,
        mode: 'text/javascript',
        theme: 'elegant',
        lineNumbers: true,
        styleActiveLine: true,
        line: true,
        matchBrackets: true
      }
    }
  },
  computed: {
    code: {
      get: function () {
        return this.$store.getters[DESIGN.GETTERS.GET_JAVASCRIPT]()
      },
      set: function (code) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.SET_JAVASCRIPT,
          code
        })
      }
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    }
  }
}
</script>
<style lang="scss">
  .plk_javascript {
    .CodeMirror {
      border: 1px solid #dee2e6;
      height: 93vh;
    }
  }
</style>
<style scoped lang="scss">
  .plk_javascript {
    background: #f8f9fa;

    .javascript {
      padding: 3vh;
      padding-left: calc(3vh + 50px);
    }
    .menu_components {
      padding: 5px;
      background: #848e98;
      height: 100vh;
      overflow: scroll;
      border-right: solid 1px #dee2e6;
    }
  }
</style>
